module.exports = __webpack_public_path__ + "img/juJia.c7d9d79f.png";